import type { useTranslation } from "react-i18next";

import { HttpError, HTTP_UNPROCESSABLE_ENTITY } from "./api";

// Человекочитаемый текст серверной ошибки мутации настроек: 422 →
// `detail` валидатора (или fallback), любой другой код / не-HttpError →
// generic-ключ. Зеркало `branchNameTemplate.serverError`.
export function serverErrorText(
  error: Error,
  t: ReturnType<typeof useTranslation>["t"],
): string {
  if (
    error instanceof HttpError &&
    error.status === HTTP_UNPROCESSABLE_ENTITY
  ) {
    return error.detail ?? t("repositorySettings.serverError.invalid");
  }
  return t("repositorySettings.serverError.generic");
}
